<div class="site-page-header-ghost-wrapper">
  <nz-page-header [ngClass]="{ 'scrolled-header': isScrolled }">
    <nz-page-header-title class="header-left">
      <button
        *ngIf="!isHamburgerVisible"
        type="button"
        nz-button
        [nzType]="'text'"
        class="hamburger-button"
        (click)="toggleSidebar($event)"
        (keydown.enter)="toggleSidebar($event)"
        tabindex="0">
        <svg-icon
          src="/assets/icon/icon-hamburger.svg"
          class="icon s-12"
          aria-label="Hamburger">
        </svg-icon>
      </button>
      <h1 class="header-title">{{ title$ | async }}</h1>
    </nz-page-header-title>

    <nz-page-header-extra>
      <ng-container *ngIf="isViewTypeAllowed && (isHomeRoute$ | async)">
        <div class="my-filter">
          <nz-form-item>
            <nz-form-label nzFor="dashboardViewSelect">View</nz-form-label>
            <nz-form-control>
              <nz-select
                id="dashboardViewSelect"
                [formControl]="isMyOnlyViewControl">
                <nz-option
                  *ngFor="let option of dashboardViewOptions"
                  [nzLabel]="option.label"
                  [nzValue]="option.value">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <ng-container *ngIf="showOrganizationSearch">
        <app-organization-search
          class="org-search"
          [isNullable]="!isManageSettignRoute"
          [defaultSelectedOrg]="selectedOrg"
          (orgChange)="orgChange($event)">
        </app-organization-search>
      </ng-container>

      <!-- Desktop View -->
      <ng-container *ngIf="!isMobile">
        <div class="cta-wrapper" *ngIf="isOrgRoute$ | async">
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            class="btn"
            (click)="openImportDrawer()">
            Import Data
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="openNewOrganizationDrawer()">
            New Organization
          </button>
        </div>

        <div
          class="cta-wrapper"
          *ngIf="
            !this.userData?.isSuperAdmin && (isInsightAdminRoute$ | async)
          ">
          <button
            nz-button
            *ngIf="activeTab === tabName.BIP"
            nzType="primary"
            (click)="openNewBipCaseDrawer()">
            New BIP Case
          </button>
          <button
            *ngIf="activeTab === tabName.PRE_BIP"
            nz-button
            nzType="primary"
            (click)="openNewPreBipCaseDrawer()">
            New Incident Tracker
          </button>
        </div>

        <div class="cta-wrapper" *ngIf="isUserManageRoute$ | async">
          <ng-container>
            <app-organization-search
              [defaultSelectedOrg]="selectedOrg"
              (orgChange)="orgChange($event)">
            </app-organization-search>
          </ng-container>
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            class="btn"
            [style.marginTop.px]="10"
            (click)="openAddUserComponentDrawer()">
            Add User
          </button>
        </div>
        <div class="cta-wrapper" *ngIf="isDashboardRoute$ | async">
          <div>
            <nz-range-picker
              [(ngModel)]="dateRange"
              [nzAllowClear]="false"
              (ngModelChange)="onDateRangeChange($event)"
              [nzFormat]="'MM/dd/yyyy'"
              [nzDisabledDate]="disabledDate">
            </nz-range-picker>

            <div
              *ngIf="dateRangeError"
              class="error-message"
              style="color: red; margin-top: 5px">
              {{ dateRangeError }}
            </div>
          </div>
        </div>

        <div class="cta-wrapper" *ngIf="isBipTemplateRoute$ | async">
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            (click)="openTemplateLogsDrawer()">
            Template Logs
          </button>
          <button
            type="button"
            nz-button
            [nzType]="'primary'"
            (click)="openAddTemplateDrawer()">
            <span class="text s-14">Add New Template</span>
          </button>
        </div>

        <div class="cta-wrapper" *ngIf="isNewStrategyRoute$ | async">
          <button
            type="button"
            nz-button
            nzType="primary"
            (click)="openNewStrategyDrawer()">
            New Strategy
          </button>
          <button
            nz-button
            [nzType]="'default'"
            (click)="exportStrategyData()"
            [nzLoading]="isExporting$ | async"
            [disabled]="isExporting$ | async">
            Export
          </button>
        </div>
        <ng-container>
          <div class="cta-wrapper" *ngIf="isNotificationRoute$ | async">
            <app-organization-search
              *ngIf="!userData?.isSuperAdmin"
              [defaultSelectedOrg]="selectedOrganizationId"
              (orgChange)="orgChange($event)">
            </app-organization-search>
            <button
              class="mt-8"
              *ngIf="showNotificationSettings || userData?.isSuperAdmin"
              type="button"
              nz-button
              [title]="'Notification Settings'"
              (click)="openNotificationsSettingsDrawer()"
              nzType="default">
              <svg-icon
                src="/assets/icon/manage-setting-ico.svg"
                class="icon s-12 cursor-pointer"
                aria-label="Manage Setting Ico">
              </svg-icon>
            </button>
          </div>
        </ng-container>

        <ng-container>
          <div class="cta-wrapper" *ngIf="isBroadcastRoute$ | async">
            <app-organization-search
              [defaultSelectedOrg]="selectedOrganizationId"
              (orgChange)="orgChange($event)">
            </app-organization-search>
            <button
              nz-button
              [nzType]="'primary'"
              (click)="openBroadcastDrawer()">
              New Broadcast
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- Mobile View -->
      <div
        class="mobile-cta-wrapper"
        *ngIf="isMobile && (showMobileCta$ | async)">
        <button
          nz-button
          nz-dropdown
          [nzDropdownMenu]="menu"
          [nzPlacement]="'bottomRight'"
          nzTrigger="click"
          [nzType]="'text'">
          <svg-icon
            [title]="'More options'"
            src="/assets/icon/icon-more.svg"
            class="icon s-16"
            aria-label="More"></svg-icon>
        </button>

        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <ng-container *ngIf="isOrgRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openImportDrawer()"
                  class="menu-button">
                  <span class="text s-14">Import Data</span>
                </button>
              </li>
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openNewOrganizationDrawer()"
                  class="menu-button">
                  <span class="text s-14">New Organization</span>
                </button>
              </li>
            </ng-container>

            <ng-container *ngIf="isInsightAdminRoute$ | async">
              <li nz-menu-item *ngIf="activeTab === tabName.BIP">
                <button
                  type="button"
                  (click)="openNewBipCaseDrawer()"
                  class="menu-button">
                  <span class="text s-14">New BIP Case</span>
                </button>
              </li>
              <li nz-menu-item *ngIf="activeTab === tabName.PRE_BIP">
                <button
                  type="button"
                  (click)="openNewPreBipCaseDrawer()"
                  class="menu-button">
                  <span class="text s-14">Create Incident Tracker</span>
                </button>
              </li>
            </ng-container>

            <ng-container *ngIf="isUserManageRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openAddUserComponentDrawer()"
                  class="menu-button">
                  <span class="text s-14">Add User</span>
                </button>
              </li>
            </ng-container>

            <ng-container *ngIf="isBipTemplateRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openTemplateLogsDrawer()"
                  class="menu-button">
                  <span class="text s-14">Template Logs</span>
                </button>
              </li>
            </ng-container>
            <ng-container *ngIf="isBipTemplateRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openAddTemplateDrawer()"
                  class="menu-button">
                  <span class="text s-14">Add New Template</span>
                </button>
              </li>
            </ng-container>

            <ng-container *ngIf="isNewStrategyRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openNewStrategyDrawer()"
                  class="menu-button">
                  <span class="text s-14">New Strategy</span>
                </button>
              </li>
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="exportStrategyData()"
                  [ngClass]="{ 'disabled-item': isExporting$ | async }"
                  class="menu-button">
                  <span class="text s-14">Export</span>
                </button>
              </li>
            </ng-container>

            <ng-container
              *ngIf="
                ((isNotificationRoute$ | async) &&
                  isPrefSettingsAdmin &&
                  selectedOrganizationId !== null &&
                  selectedOrganizationId !== 0 &&
                  selectedOrganizationId !== undefined) ||
                userData?.isSuperAdmin
              ">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openNotificationsSettingsDrawer()"
                  class="menu-button">
                  <span class="text s-14">Notification Settings</span>
                </button>
              </li>
            </ng-container>

            <ng-container *ngIf="isBroadcastRoute$ | async">
              <li nz-menu-item>
                <button
                  type="button"
                  (click)="openBroadcastDrawer()"
                  class="menu-button">
                  <span class="text s-14">New Broadcast</span>
                </button>
              </li>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<ng-template #importFooterTpl>
  <div class="display-flex justify-content-between drawer-footer">
    <button nz-button nzType="default">Cancel</button>
    <button nz-button nzType="primary">Import File</button>
  </div>
</ng-template>
<ng-template #drawerTemplateLog>
  <app-drawer-header
    [title]="'Template Logs'"
    subtitle="Template Logs"
    [breadcrumbText]="'BIP Template'"
    (drawerClose)="closeTemplateLogDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerAddTemplate>
  <app-drawer-header
    [title]="'Add BIP Template'"
    subtitle="Add BIP Template"
    [breadcrumbText]="'BIP Template'"
    (drawerClose)="closeAddTemplateDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #drawerNewStrategy>
  <app-drawer-header [title]="'New Strategy'" subtitle="" [breadcrumbText]="''">
  </app-drawer-header>
</ng-template>

<ng-template #drawerAddUser>
  <app-drawer-header [title]="'Add User'"> </app-drawer-header>
</ng-template>
